<template>
  <section>
    <div v-if="pax && !pax.is_expired_taxi_p2c" class="photo-pay-container">
      <div v-if="!service || !service.price_per_person">
        <div class="container">
          <div v-if="lang[2]" class="mt-3">
            <p>{{ lang[2].SFS_LANG_ROW_9 }}</p>
          </div>
        </div>
      </div>
      <div v-else-if="lang && lang.taxi" id="photo-pay" class="photo-pay pt-3">
        <div>
          <div class="photo2claim">
            <PhotoPayStep
              v-if="step == 1"
              :secret="secret"
              :taxi-info="TaxiInfoPax"
              :taxi-price="groupPrice"
              :voucher="voucher"
              :index-booking="indexBooking"
              @nextStep="nextStep"
            />
          </div>
        </div>
        <PhotoPayInfo
          v-if="step == 2"
          :secret="secret"
          :taxi-info="TaxiInfoPax"
          :taxi-price="groupPrice"
          :index-booking="indexBooking"
          :service="service"
        />
      </div>
    </div>
    <div v-else-if="pax && pax.is_expired_taxi_p2c">
      <div class="container">
        <div v-if="lang.expire_link" class="mt-3">
          <p>{{ lang.expire_link.SFS_LANG_ROW_4 }}</p>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import '@/assets/scss/modules/PhotoPay.scss'
import PhotoPayStep from './PhotoPayStep'
import PhotoPayInfo from './PhotoPayInfo'
import { mapGetters } from 'vuex'

export default {
  components: { PhotoPayStep, PhotoPayInfo },
  props: {
    secret: {
      type: String,
      default: ''
    },
    voucher: {
      type: Object,
      default: () => {}
    },
    indexBooking: {
      type: Number,
      default: 0
    },
    taxiService: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      step: 1,
      TaxiInfoPax: {},
      groupPrice: {},
      curPaxId: null,
      service: {}
    }
  },
  computed: {
    ...mapGetters({
      TaxiInfo: 'Taxi/TaxiInfo',
      TaxiPrice: 'Taxi/TaxiPrice',
      Services: 'Home/Services',
      dataInfoBankPax: 'Refreshment/dataInfoBankPax'
    })
  },
  watch: {
    TaxiInfo: {
      handler() {
        this.checkStep()
      },
      deep: true
    },
    Services: {
      handler() {
        this.checkStep()
      },
      deep: true
    },
    airline: function () {
      if (this.airline.meal_enabled != '2') {
        let secret = this.$route.query.secret
        this.$router.push({ path: '/home', query: { secret: secret } })
      }
    },
    TaxiPrice: {
      handler() {
        this.filterGroupPrice()
      },
      deep: true
    },
    curPaxId: {
      handler() {
        this.filterGroupPrice()
      },
      deep: true
    }
  },
  created() {
    this.$store.dispatch('Taxi/getPriceTaxi')
  },
  mounted() {
    this.checkStep()
    this.initData()
  },
  methods: {
    nextStep(data) {
      this.step = data
    },
    initData() {
      let self = this
      this.$store.dispatch('Taxi/getTaxiInfo', {
        taxiDetailId: this.service?.taxi_booking_detail[this.indexBooking]?.id
      })
      self.curPaxId = self.pax?.id || self.pax.curPaxID
      if (self.service && self.curPaxId) {
        self.filterGroupPrice()
      }
    },
    checkStep() {
      let self = this
      if (self.Services.length == 0) {
        self.$store.dispatch('Home/getServices')
      }
      self.service = _.find(self.Services, { service_id: 4 })
      if (!self.service || _.isEmpty(self.service.price_per_person)) {
        return false
      }
      if (self.TaxiInfo && self.TaxiInfo.bank_info) {
        self.TaxiInfoPax = self.TaxiInfo
        if (self.TaxiInfo.bank_info && !_.isEmpty(self.TaxiInfo.bank_info.transfer_bank_info)) {
          self.step = 2
        } else {
          self.step = 1
        }
      } else {
        self.$store.dispatch('Taxi/getTaxiInfo', {
          taxiDetailId: self.service?.taxi_booking_detail[self.$route.query.indexBooking]?.id
        })
      }
    },
    filterGroupPrice() {
      let self = this
      let matrixShareTaxi =
        !_.isUndefined(self.service.params) &&
        !_.isUndefined(self.service.params.matrix_share_taxi) &&
        self.service.params.matrix_share_taxi
          ? [...self.service.params.matrix_share_taxi]
          : []
      if (_.isUndefined(self.curPaxId) || !self.TaxiPrice) {
        return
      }
      let paxGroup = _.find(matrixShareTaxi, function (group) {
        return _.indexOf(group, self.curPaxId?.toString()) >= 0
      })
      if (!_.isUndefined(paxGroup) && paxGroup.length) {
        self.groupPrice = _.map(paxGroup, function (paxId) {
          return _.find(self.TaxiPrice, { passenger_id: parseInt(paxId) })
        })
      } else {
        self.groupPrice = self.TaxiPrice
      }
    }
  }
}
</script>
